import { useQueryClient, useMutation } from '@tanstack/react-query';
import { insertStructuralHierarchySubOrg } from "../orgPanelApiCalls";
import { key as structuralHierachyKey } from "../queries/useStructuralHierachyQuery";
import { useStore } from "../appStore"

const useInsertHierachySuborgMutation = () => {
    const queryClient = useQueryClient()
    const orgId = useStore((state) => state.CurrentOrganizationId);

    return useMutation({
        
        mutationFn: async (variables) => await insertStructuralHierarchySubOrg(orgId, variables.parentId, variables.name),
        onSuccess: (data, variables) => {
            //add the new record to cache
            queryClient.setQueryData([structuralHierachyKey], (previousData) => {
                // ensure we always return a valid array
                const safeData = Array.isArray(previousData) ? previousData : [];
                return [...safeData,
                {
                    accountId: data.accountId,
                    structuralAccountTypeId: data.accountTypeId,
                    name: data.name,
                    parentId: variables.parentId
                }];
            });
        }
    })
}

export { useInsertHierachySuborgMutation };